import Axios from "axios";
import {
  Cheques,
  ChequesResponse,
  GetChequesRequest,
} from "../models/chequeProsses.model";
import { ApiResultModel } from "../models/common.model";
import { ApiBaseUrl, ChequeProssesURL } from "../config/config";

export const GetChequeForShowInProsses = async (
  data: GetChequesRequest
): Promise<ApiResultModel<ChequesResponse[]>> => {
  return await Axios.post<ApiResultModel<ChequesResponse[]>>(
    ApiBaseUrl + ChequeProssesURL + "/GetChequeForShowInProsses",
    data
  ).then((result) => {
    return result.data;
  });
};

export const ProssesCheque = async (
  data: Cheques[]
): Promise<ApiResultModel<ChequesResponse[]>> => {
  return await Axios.post<ApiResultModel<ChequesResponse[]>>(
    ApiBaseUrl + ChequeProssesURL + "/ProssesCheque",
    data
  ).then((result) => {
    return result.data;
  });
};
